/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'fm-balloon-section',
  templateUrl: './balloon-section.component.html',
  styleUrls: ['./balloon-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BalloonSectionComponent {
  @Input()
  public showDivider = true;

  @HostBinding('class.balloon-section')
  hostClass = true;
}
